import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import Overlay from "../components/Overlay";
import { User, UserPlus, Lock, Phone, Key } from 'lucide-react';


import api from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import Header from "../components/Header";

export default function Register() {
    const { isAuthenticated, setAccessToken } = useAuth();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [referrer, setReferrer] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [otp, setOtp] = useState("");

    const [phoneError, setPhoneError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const [timer, setTimer] = useState(0);
    const [loadingSend, setLoadingSend] = useState(false);
    const [Error, setError] = useState("");

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard')
        }
    }, [isAuthenticated])

    const validatePhone = (value: string) => {
        if (!value) {
            setPhoneError("invalid input");
            return false;
        }

        if (/[^0-9]/.test(value)) {
            setPhoneError("Only digits allowed");
            return false;
        }

        setPhoneError("");
        return true;
    };

    const handlePhoneChange = (e: { target: { value: any; }; }) => {
        let val = e.target.value;
        if (validatePhone(val)) {
            setPhone(val);
        }
    };

    const handlePasswordChange = (e: { target: { value: any; }; }) => {
        const val = e.target.value;
        setPassword(val);

        if (val.length < 6) {
            setPasswordError("Password must be at least 6 characters");
            return;
        }
        setPasswordError("");
    };

    const startTimer = () => {
        let time = 120;
        setTimer(time);

        const interval = setInterval(() => {
            time--;
            setTimer(time);
            if (time <= 0) clearInterval(interval);
        }, 1000);
    };

    const requestOtp = async () => {
        if (!validatePhone(phone)) return;

        setLoadingSend(true);

        try {
            const response = await api.post('/sendotp', { phone: phone });
            if (response.status !== 200) {
                setError('!!!مشکل در ارسال کد');
            }
        } catch (err) {
            setError('!!!مشکل در ارسال کد');
        }

        startTimer();
        setLoadingSend(false);
    };

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        const okPhone = validatePhone(phone);
        const okPass = password.length >= 6;
        const okotp = otp.length == 6;
        if (!okPhone || !okPass || !okotp) return;

        try {
            const response = await api.post('/register', { full_name: name, referrer, phone, password, otp_code: otp });
            if (response.status === 201) {
                const access_token = response.data.token;

                setAccessToken(access_token);
                document.cookie = `gt=${access_token}; path=/; max-age=${60 * 60 * 24 * 30
                    }; SameSite=Lax; Secure`;

                setAccessToken(response.data.token);
                navigate('/dashboard');
            }
            else setError('!!!مشکل در ثبتنام');

        } catch (err) {
            setError('!!!مشکل در ثبتنام');
        }
    };

    return (
        <div className="min-h-[100dvh] max-h-[100dvh] w-full bg-darkbg text-white overflow-x-hidden overflow-y-auto relative font-yekan">
            <Overlay active={menuOpen} close={() => setMenuOpen(false)} />
            <MobileMenu active={menuOpen} />

            <div className="fixed inset-0 z-0">
                <div
                    className="absolute inset-0 z-10"
                    style={{
                        backgroundImage: `linear-gradient(to bottom, 
                        #191919 0%, 
                        #191919 45%, 
                        #191919 60%, 
                        rgba(25, 25, 25, 0.9) 70%, 
                        rgba(25, 25, 25, 0.2) 100%
                    )`
                    }} />

                <div
                    className="md:w-1/2 ml-auto absolute inset-0 bg-cover bg-bottom md:bg-right-bottom bg-no-repeat"
                    style={{
                        backgroundImage: `url("../assets/img/bg.jpg")`,
                    }}
                />
            </div>


            <header dir='rtl' className={`md:absolute md:right-0 flex justify-between items-center py-4 px-6 relative z-60 
                           bg-gradient-to-t from-transparent to-[rgba(0,0,0,0.3)]
                           transition-all duration-500 ease-in-out`}>
                <button onClick={() => setMenuOpen(!menuOpen)}
                    className={`z-50 p-2 rounded-full backdrop-blur-sm 
                           flex justify-center items-center transition-all duration-500 ease-in-out
                           hover:bg-white/20 ${menuOpen ? 'rotate-90' : ''}`}>

                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 scale-150" fill="none" viewBox="0 0 24 24" stroke="#f4b400" strokeWidth="2">
                        {menuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                        )}
                    </svg>
                </button>
            </header>

            <div className="relative z-20 md:min-h-screen min-h-fit max-h-screen flex flex-col md:flex-row">

                <div className="hidden md:flex md:w-1/2 flex-col justify-center items-center bg-primary backdrop-blur-sm">
                    <img
                        className="w-52 mb-6"
                        src="../assets/img/desktop-logo.png"
                        alt="GRIT LOGO"
                    />
                    <p className="text-gray-900 text-2xl tracking-wider text-center px-8">
                        Discover the world.<br />Walk with us.
                    </p>
                </div>

                <div className="flex-1 flex items-center justify-center px-5 pb-5 md:py-10 md:w-1/2">
                    <form
                        onSubmit={handleSubmit}
                        className="w-full max-w-[380px] rounded-3xl px-8 pb-8 md:p-10 "
                    >

                        <div className="inset-0 flex justify-center items-center pointer-events-none h-[70px] aspect-[3/1] mx-auto">
                            <img src={"../assets/img/logo.png"} alt="Logo" className=" object-cover" />
                        </div>

                        <div className="flex justify-center aspect-[2/1]">
                            <img
                                className="w-full object-cover"
                                src="../assets/img/typo.png"
                                alt="GRIT LOGO"
                            />
                        </div>

                        <div className="space-y-4">
                            <div className="relative">
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="نام و نام خانوادگی"
                                    maxLength={50}
                                    className="w-full px-4 py-3 rounded-full bg-[#191919] border border-white text-white text-right placeholder:text-gray-400 focus:outline-none focus:border-primary transition"
                                />
                                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" strokeWidth={2} />
                            </div>

                            <div className="relative">
                                <input
                                    type="text"
                                    value={referrer}
                                    onChange={(e) => setReferrer(e.target.value)}
                                    placeholder="معرف (اختیاری)"
                                    maxLength={50}
                                    className="w-full px-4 py-3 rounded-full bg-[#191919] border border-white text-white text-right placeholder:text-gray-400 focus:outline-none focus:border-primary transition"
                                />
                                <UserPlus className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" strokeWidth={2} />
                            </div>

                            <div className="relative">
                                <input
                                    type="password"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    placeholder="رمز عبور"
                                    className={`w-full px-4 py-3 rounded-full bg-[#191919] border text-white text-right placeholder:text-gray-400 focus:outline-none transition
                ${passwordError ? "border-red-500" : "border-white"}`}
                                />
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" strokeWidth={2} />
                                {passwordError && <span className="text-red-400 text-xs mt-1 block">{passwordError}</span>}
                            </div>

                            <div className="relative">
                                <input
                                    type="tel"
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    placeholder="09xxxxxxxxx"
                                    maxLength={11}
                                    className={`w-full px-4 py-3 rounded-full bg-[#191919] border text-white text-right placeholder:text-gray-400 focus:outline-none transition
                ${phoneError ? "border-red-500" : "border-white"}`}
                                />
                                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" strokeWidth={2} />
                                {phoneError && <span className="text-red-400 text-xs mt-1 block">{phoneError}</span>}
                            </div>

                            <div className="relative">
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="رمز یکبار مصرف"
                                    className="w-full px-4 py-3 rounded-full bg-[#191919] border border-white text-white text-right placeholder:text-gray-400 focus:outline-none focus:border-primary transition"
                                />
                                <Key className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" strokeWidth={2} />
                            </div>

                            {Error && <div className="text-red-400 text-sm text-center">{Error}</div>}

                            <button
                                type="button"
                                onClick={requestOtp}
                                disabled={loadingSend || timer > 0}
                                className="w-full py-3 rounded-2xl bg-gray-700 hover:bg-gray-600 transition disabled:opacity-50 text-white font-medium"
                            >
                                {timer > 0
                                    ? `${timer} ثانیه تا درخواست مجدد`
                                    : loadingSend
                                        ? "در حال ارسال..."
                                        : "دریافت رمز یکبار مصرف"
                                }
                            </button>

                            <button
                                type="submit"
                                className="w-full mt-3 bg-primary hover:bg-yellow-500 active:scale-[0.985] transition
                 text-black font-semibold py-3 rounded-full text-lg"
                            >
                                ثبت نام
                            </button>
                        </div>

                        <p
                            onClick={() => navigate("/login")}
                            className="mt-6 text-center text-primary hover:text-yellow-300 cursor-pointer transition max-w-fit mx-auto"
                        >
                            حساب کاربری دارید؟
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}